<template lang="html">
  <nav class="navbar is-dark">
    <div class="container top-bar is-fluid">
      <div class="navbar-brand">
        <div class="navbar-item" title="Home">
          <div class="top-logo"/>
        </div>
      </div>

      <div class="user-section">
        <template v-if="currentUser">
            <span class="navbar-item">
              <b-icon pack="fas" icon="user-circle"/>              &nbsp;
               {{ currentUser.email }}
            </span>
          <a class="navbar-item logout-btn" href="#" @click.prevent="logout" title="Logout">
            <b-icon pack="fas" icon="sign-out-alt"/>
          </a>
        </template>

      </div>
    </div>
  </nav>
</template>

<script>
import NotificationService from '@/services/NotificationService'
import { mapGetters } from 'vuex'

export default {
  name: 'Navbar',

  data () {
    return {
      orderReference: '',
      IsActive: false
    }
  },

  created () {
    if (this.$route.params.reference) {
     this.orderReference = this.$route.params.reference;
    }
  },

  computed: {
    ...mapGetters({currentUser: "auth/currentUser"})
  },

  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
      NotificationService.message('You are logged out now...')
    }
  }
}
</script>
